export default __webpack_public_path__ + "static/media/editDeepBlue.cded552c.svg";